import { EnumClass } from '~/types/common/shop-common-code'

export default Object.freeze({
  ME020: {
    ACT_GOODS_ORDER: new EnumClass({ code: '11', name: '상품구입(활동포인트)' }),
    ACT_GOODS_REVIEW: new EnumClass({ code: '12', name: '상품평(활동포인트)' }),
    MLG_ORDER_ACUM: new EnumClass({ code: '21', name: '주문적립' }),
    MLG_GRADE_ACUM: new EnumClass({ code: '22', name: '고객등급별적립' }),
    MLG_RESERV_ACUM: new EnumClass({ code: '23', name: '예약상품적립' }),
    MLG_PROMO_ACUM: new EnumClass({ code: '24', name: '프로모션적립' }),
    MLG_REVIEW_ACUM: new EnumClass({ code: '25', name: '상품평적립' }),
    MLG_EVT_ACUM: new EnumClass({ code: '26', name: '이벤트적립' }),
    MLG_REWARD_ACUM: new EnumClass({ code: '27', name: '보객보상적립' }),
    MLG_ADJ_ACUM: new EnumClass({ code: '28', name: '플러스조정: new EnumClass({ code: 기타사유)' }),
    MLG_REFUND_ACUM: new EnumClass({ code: '29', name: '환불적립' }),
    MNAL_CLAIM_ACUM: new EnumClass({ code: '40', name: '수기지급-클레임' }),
    MNAL_EVT_ACUM: new EnumClass({ code: '41', name: '수기지급-이벤트' }),
    MLG_ORDER_USE: new EnumClass({ code: '50', name: '주문사용' }),
    MLG_ORDER_CHG_USE: new EnumClass({ code: '51', name: '주문변경' }),
    MLG_ETC_USE: new EnumClass({ code: '53', name: '기타사용' }),
    MLG_ADJ_USE: new EnumClass({ code: '54', name: '마이너스조정(기타사유)' }),
    MLG_EXPIRE_USE: new EnumClass({ code: '55', name: '기간만료' }),
    MLG_EXPIRE_ADJ_USE: new EnumClass({ code: '56', name: '마이너스조정(기간만료)' }),
    MLG_EXCHG_COUPON_USE: new EnumClass({ code: '57', name: '쿠폰전환' }),
    MLG_DLVP_USE: new EnumClass({ code: '58', name: '배송비사용' }),
  },
  ME035: {
    GOODS: new EnumClass({ code: '10', name: '상품' }),
    BRAND: new EnumClass({ code: '20', name: '브랜드' }),
    PLAN_SHOP: new EnumClass({ code: '30', name: '기획전' }),
  },
  ME039: {
    BEFORE_SHIPPING_CALL_MESSAGE: new EnumClass({ code: '20', name: '배송 전 연락주세요' }),
    PUT_IN_THE_DELIVERY_BOX: new EnumClass({ code: '30', name: '택배함에 넣어주세요' }),
    LEAVE_SECURITY_OFFICE_MESSAGE: new EnumClass({ code: '40', name: '부재 시 경비실에 맡겨주세요' }),
    FRAGILE_PRODUCE_CAREFUL_SHIPPING_MESSAGE: new EnumClass({ code: '50', name: '파손 위험 상품입니다. 배송 시 주의해주세요.' }),
    LEAVE_DOOR_AWAY_MESSAGE: new EnumClass({ code: '60', name: '부재 시 문 앞에 놓아주세요' }),
    DIRECT_INPUT_MESSAGE: new EnumClass({ code: '70', name: '직접입력' }),
  },
})
